// ** MUI Imports
import { 
    IconButton, 
    Tooltip, 
    Typography, 
    useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import { InformationOutline } from 'mdi-material-ui'

// ** Child Imports
import AdvanceDatePicker from 'src/components/common/search-and-filters/subcomponents/AdvanceDatePicker'

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'

// ** Context
import { useFilter } from 'src/lib/contexts/FilterContext'

// ** Types
import { TabType } from 'src/lib/types/filters'


// ** Helpers    
import {
    dashboardTabs } from 'src/lib/utils/constants'
import { 
    appliedDateFilter, 
    getDateTime } from 'src/lib/utils/helpers'

import OverviewLayoutBuilder from 'src/components/analytics-dashboard/OverviewLayoutBuilder'
import { RefreshCw } from 'react-feather'


const AnalyticsDashboard = () => {

    const theme = useTheme();
    const { analyticsFilters, setAnalyticsFiltersCtx } = useFilter();

    return (
        <div 
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 16
            }}
        >
            <div className='flex flex-col p-4 gap-4 md:p-0'>
                {/* Header */}
                <Typography 
                    variant='h6'
                    sx={{ 
                        fontWeight:600,
                        color: 'text.header'    
                    }}
                    >
                    Overview
                </Typography>
            
                {/* Filter sections */}
                <Grid 
                    container 
                    display={"flex"} 
                    alignItems={"center"} 
                    gap={2}
                    justifyContent={"space-between"}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <AdvanceDatePicker 
                            appliedFilter={appliedDateFilter(analyticsFilters)} 
                            minDateValue={new Date(2022, 8, 20)}
                            maxDateValue={new Date()}
                            parentComponent={dashboardTabs.FLO_ANALYTICS_TAB as TabType}
                            comparison
                        />
                        <Tooltip 
                            sx={{ 
                                marginRight: '0.5rem', 
                                marginBottom: '0.1rem', 
                                cursor: "pointer", 
                                fill: 'grey' 
                            }}
                            title="Conversion data available for Jan 2nd 2023 and onwards." >
                            <InformationOutline fontSize="small"/>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span className='text-sm mr-1 mb-[1px] text-coal-light' >Last updated </span>
                        <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                            <span style={{ color: theme.palette.text.primary, fontWeight: 600 }}>{analyticsFilters?.lastUpdated}</span>
                        </Typography>
                        <IconButton
                            id='analytics-refresh-button'
                            aria-label="close"
                            size="small"
                            onClick={() => {    
                                setAnalyticsFiltersCtx({ 
                                    ...analyticsFilters,
                                    lastUpdated: `${getDateTime(new Date()).date} at ${getDateTime(new Date()).time}` 
                                });
                            }}
                        >
                            <RefreshCw id='analytics-refresh-button-icon' className='text-coal-dark stroke-[2.5px] h-4 w-4' />
                        </IconButton>
                    </div>
                </Grid>
            </div>

            <OverviewLayoutBuilder />   
        </div>
    )
}

export default AnalyticsDashboard

